export const aiContactDataArabic = {
  heading: "احصل على استشارة مجانية لمدة 30 دقيقة",
  subHeading: "بقيمة 250 دولارًا.",
  contactSections: [
    {
      title: "شبكة المواهب الماهرة",
      description: "يتكون فريقنا من محترفين ذوي خبرة عالية.",
    },
    {
      title: "تنفيذ سريع",
      description: "نقدّم حلولًا سريعة وفعالة رغم ضيق الوقت.",
    },
    {
      title: "حلول فعّالة من حيث التكلفة",
      description: "نقدّم خدمات عالية الجودة تُعظم استفادتك من الميزانية.",
    },
    {
      title: "تطوير قائم على الابتكار",
      description: "نركّز على تقديم حلول مبتكرة ومتقدمة ومخصصة.",
    },
  ],
  nameField: {
    placeholder: "اسمك",
    label: "اسمك",
  },
  emailField: {
    placeholder: "أدخل البريد الإلكتروني",
    label: "أدخل بريدك الإلكتروني",
  },
  phoneField: {
    placeholder: "أدخل رقم الهاتف",
    label: "أدخل رقم الهاتف",
  },
  companyField: {
    placeholder: "أدخل اسم الشركة",
    label: "أدخل اسم الشركة",
  },
  projectDetailsField: {
    placeholder: "تفاصيل المشروع",
    label: "تفاصيل المشروع",
  },

  submit: "إرسال",
  loading: "جارٍ التحميل...",
};
